import EmptyGraph from './empty-graph'

export default EmptyGraph
